export default __webpack_public_path__ + "static/media/fsd.b23a1276.png";